import styled from 'styled-components';
import Background from '../../assets/AboutContainer/background.png'

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  font-family: 'Arial', sans-serif;
  color: #222;
`;

export const ContainerAbout = styled.div`
  width: 100%;
  background: linear-gradient(0deg, rgb(252, 252, 252) 35%, rgb(226, 223, 223) 100%);
`

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 0;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;

   
  @media (max-width: 550px) {
    /* Phones */
    flex-direction: column-reverse;
    justify-content: center;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

export const SectionCircle = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 4em 0;

`

export const ImageCircle = styled.div`
  width: 50%;
  padding-left: 5em;
`

export const SquareImage = styled.div`
  opacity: 0.3;
  position: absolute;
  margin-top: -21em;
  z-index: 1;
`

export const SectionValues = styled.div`
background-image: url(${Background});
  display: flex;
  flex-direction: column;
  width: 100%;
  background-size: cover;
  background-position: center;
  padding-bottom: 3em;
`

export const ContainerList = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 3em;

    @media (max-width: 550px) {
    /* Phones */
    display: flex;
    flex-direction: column;
  }
`

export const TextBlock = styled.div`
  flex: 1;
  line-height: 1;

  @media (max-width: 550px) {
    /* Phones */
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

`;

export const Title = styled.h1`
  font-size: 2.5em;
  font-weight: bold;
  margin-top: -3em;

  @media (max-width: 550px) {
    /* Phones */
    margin-top: 0;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    margin-top: 0;
  }
`;

export const LogoImage = styled.img`
  width: 250px;
  margin-top: 5em;

  @media (max-width: 550px) {
    /* Phones */
    margin-top: 2em;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    margin-top: 2em;
  }
`;

export const Doctor = styled.img`
  width: 50%;

  @media (max-width: 550px) {
    /* Phones */
    width: 80%;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 80%;
  }

`;

export const Ampoules = styled.img`
  width: 40%;

  @media (max-width: 550px) {
    /* Phones */
    width: 80%;
    align-self: flex-end;
    margin-top: 2em;
  }
`;

export const Hands = styled.img`
  width: 50%;
`;

export const Subtitle = styled.h2`
  font-size: 3em;
  font-weight: bold;
  padding-left: 3em;

  @media (max-width: 550px) {
    /* Phones */
    padding-left: 1em;
    font-size: 4em;
    line-height: 1;
    margin-top: 1em;
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
`;

export const ListItem = styled.li`
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
   font-size: 2.5em;
   padding-left: 5em;

   @media (max-width: 550px) {
    /* Phones */
    padding-left: 1em;
  }
`;

export const ListItemHonesty = styled.li`
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
   font-size: 2.5em;
   padding-left: 8em;
   margin-top: 1.5em;

   
   @media (max-width: 550px) {
    /* Phones */
    padding-left: 1em;
  }
`

export const ListItemOther = styled.li`
    font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
   font-size: 2.5em;
   padding-left: 8em;

   @media (max-width: 550px) {
    /* Phones */
    padding-left: 1em;
  }
`

export const RedDot = styled.span`
  width: 8px;
  height: 8px;
  background-color: red;
  display: inline-block;
`;

export const BlackDot = styled.span`
  width: 6px;
  height: 6px;
  background-color: black;
  display: inline-block;
  border-radius: 50%;
  margin-right: 5px;
`;

export const Description = styled.li`
  width: 60%;
  color: #555;
  padding-left: 12.5em;

  
  @media (max-width: 550px) {
    /* Phones */
    padding-left: 2.3em;
  }
`;

export const DescriptionEthic = styled.li`
  width: 60%;
  color: #555;
  padding-left: 20.3em;
  display: flex;
  align-items: center;

  @media (max-width: 550px) {
    /* Phones */
    padding-left: 3em;
  }

`

export const Commitment = styled.div`
  background: #f0f0f0;
  padding: 20px;
  text-align: center;
  font-weight: bold;

  width: 100%;
  font-size: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5em 0;

  p{
    width: 40%;
  }

  @media (max-width: 550px) {
    /* Phones */
    font-size: 2em;

    p{
      width: 80%;
      
    }
  }
`;

export const HandsSection = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;

  img{
    width: 45%;
  }

  @media (max-width: 550px) {
    /* Phones */
    margin-top: -5em;
  }
`

export const CircleAnimation = styled.div`
  position: absolute;
  left: 70%;
  margin-top: -40px;
`